(function () {
	const DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

	const DEFAULT_LOCALE = "en-US";
	const DEFAULT_LOCALE_OPTIONS = { timeZone: "America/Toronto" };
	const DEFAULT_WEEKDAY_DATES_FORMAT = { weekday: 'long' };
	const DEFAULT_CUTOFF_DATES_FORMAT = { weekday: 'long', hour: 'numeric' };
	const DEFAULT_DATES_FORMAT = { weekday: 'long', month: 'long', day: 'numeric' };

	const CUTOFF_TIME = 2359;
	const MOBILE_BREAKPOINT = 767;

	const LOCALE_CODE = Shopify.locale + "-CA";
	const LOCALE_CODE_FR = "fr";
	const LOCALE_STRING_EN = " or ";
	const LOCALE_STRING_FR = " ou le ";

	const SELECTORS = {
		dateSelector: '.date-selector',
		deliveryTime: '.selector-delivery-time',
		weekIndicator: '.js-selector-week-indicator',

		countdownDelivery: '#countdown-delivery',
		countdownCutoff: '#countdown-cutoff',
		blockDay: '#day-block',
		blockHour: '#hour-block',
		blockMinute: '#minute-block',
		blockSecond: '#second-block',
		selectorContainer: '#selector-container',
		selectorContainerMobile: '#selector-container-mobile',
		selectedDay: '#selected-day',
		deliveryDate: '#delivery-date',
		deliveryDay: '#delivery-day',
		deliveryTimeId: '#delivery-time',

		selectedDayByName: '[name="selected-day"]',
		deliveryDateByName: '[name="attributes[Date de livraison]"]',
		deliveryDayByName: '[name="attributes[Jour de livraison]"]',
		deliveryTimeByName: '[name="attributes[Heure de livraison]"]',
		selectorDeliveryTimeByName: '[name="selector-delivery-time"]',

		slider: '#selector-slider',
		weeklySlider: '#weekly-slider',
		sliderNavNext: '.selector-slider-wrapper .swiper-button-next',
		sliderNavPrev: '.selector-slider-wrapper .swiper-button-prev',
		weeklySliderNavNext: '.weekly-menu .swiper-button-next',
		weeklySliderNavPrev: '.weekly-menu .swiper-button-prev',
		weeklySlide: '[data-weekly-products]',

		mobileSlider: '.off-canvas--main-content #selector-slider-mobile',
		mobileSliderNavNext: '.off-canvas--main-content .selector-slider-wrapper-mobile .swiper-button-next',
		mobileSliderNavPrev: '.off-canvas--main-content .selector-slider-wrapper-mobile .swiper-button-prev'

	};

	Date.prototype.addDays = function(days) {
		let date = new Date(this.valueOf());
		date.setDate(date.getDate() + days);
		return date;
	};

	//Setup
	document.addEventListener("DOMContentLoaded", setup);

	document.addEventListener('cart:html:updated', ()=> {
		setup();
	});

	//Functions
	function setup() {
		const countdownDelivery = document.querySelectorAll(SELECTORS.countdownDelivery);
		const countdownCutoff = document.querySelectorAll(SELECTORS.countdownCutoff);

		countdownDelivery.forEach((countdown, index) => {
			let countdownWrapper = countdown.closest('.countdown-wrapper');

			let interval = +countdown.getAttribute('data-countdown-delivery');

			let myPlannedDelivery = new DatedDelivery([7], 3, CUTOFF_TIME, interval);
			let myOtherPlannedDelivery = new DatedDelivery([7], 3, CUTOFF_TIME, interval);

			let mySettings = new DateSettings([myOtherPlannedDelivery, myPlannedDelivery]); //Generated from theme settings

			let countdownDeliveryLabel = "";

			let deliveryDays = mySettings.plannedDeliveries[0].deliveryDays;

            console.log(mySettings.plannedDeliveries)
            console.log(deliveryDays);

			for (let i = 0; i < deliveryDays.length; i++) {
				countdownDeliveryLabel += deliveryDays[i].toLocaleDateString(LOCALE_CODE, DEFAULT_DATES_FORMAT);

				if (i < deliveryDays.length - 1) {
					let localString = LOCALE_STRING_FR;
					if (Shopify.locale !== LOCALE_CODE_FR) {
						localString = LOCALE_STRING_EN;
					}

					countdownDeliveryLabel += localString;
				}
			}

			if (countdown) {
				countdown.innerHTML = countdownDeliveryLabel;
			}

			if (countdownCutoff[index]) {
				countdownCutoff[index].innerHTML = mySettings
					.plannedDeliveries[0]
					.cutoffDate
					.toLocaleDateString(LOCALE_CODE, DEFAULT_CUTOFF_DATES_FORMAT);
			}

			if (document.querySelector(SELECTORS.blockDay)) {
				const blockDay = countdownWrapper.querySelectorAll(SELECTORS.blockDay);
				const blockHour = countdownWrapper.querySelectorAll(SELECTORS.blockHour);
				const blockMinute = countdownWrapper.querySelectorAll(SELECTORS.blockMinute);
				const blockSecond = countdownWrapper.querySelectorAll(SELECTORS.blockSecond);

				var secondInterval = 1000;
				var x = setInterval(function() { countdownTimer(mySettings, blockDay, blockHour, blockMinute, blockSecond); }, secondInterval);
			}
		});

		initWeeklySlider();
		setWeekForProducts();
		checkWeeklyCollection();
		cartMenuStyle();
	}

	function DateSettings(datedDeliveries) {
		this.plannedDeliveries = datedDeliveries;

		this.sortDates = function() {
			this.plannedDeliveries.sort((a, b) => a.cutoffDate.getTime() - b.cutoffDate.getTime());
		}

		this.sortDates();
	}

	function DatedDelivery(deliveryDays, cutoffDay, cutoffTime, interval) {
		let date = new Date();

		if (interval) {
			date.setDate(date.getDate() + interval);
		}

		const todayCutoff = new Date(date.toLocaleString(DEFAULT_LOCALE, DEFAULT_LOCALE_OPTIONS));

		const cutoffHour = Math.floor(cutoffTime/100);
		const cutoffMinute = cutoffTime%100;

		if (todayCutoff.getHours() < cutoffHour) {
			todayCutoff.setHours(cutoffHour,cutoffMinute,0,0);
		}

		this.deliveryDays = [];
		this.cutoffDate = getNextDayOfWeek(cutoffDay, todayCutoff);
		this.cutoffDate.setHours(Math.floor(cutoffTime / 100),cutoffTime % 100); //plannedDelivery.cutoffTime;

		for (let dDays of deliveryDays) {
			this.deliveryDays.push(getNextDayOfWeek(dDays, this.cutoffDate));
		}
	}

	function generateFutureDatedDeliveryByRange(deliveryDays, startDate, endDate) {
		const start = new Date(startDate);
		const end = new Date(endDate);

		const deliveryDaysDates = [];

		let index = 0;
		let next = true;
		while(next) {
			index++;
			start.setDate(start.getDate() + 1);

			if (deliveryDays.includes(start.getDay())) {
				const date = new Date(start);
				deliveryDaysDates.push(date);
			}

			next = start < end
				? true
				: index % 7;
		}

		return deliveryDaysDates;
	}

	function getNextDayOfWeek(dayOfWeek, fromDate) {
		let resultDate = fromDate; //new Date(new Date().toLocaleString("en-US", {timeZone: "America/Toronto"}));

		let daysOffset = (7 + dayOfWeek - fromDate.getDay()) % 7;
		resultDate = resultDate.addDays(daysOffset);

		resultDate.setHours(fromDate.getHours(),fromDate.getMinutes(),0,0);
		if (resultDate.getTime() < fromDate.getTime()) {
			resultDate = resultDate.addDays(7);
		}

		return resultDate;
	}

	function countdownTimer(dateSettings, blockDay, blockHour, blockMinute, blockSecond) {
		let now = new Date(new Date().toLocaleString(DEFAULT_LOCALE, DEFAULT_LOCALE_OPTIONS));

		// Find the distance between now and the countdown date
		let distance = dateSettings.plannedDeliveries[0].cutoffDate - now;

		// Time calculations for days, hours, minutes and seconds
		let days = Math.floor(distance / (1000 * 60 * 60 * 24));
		let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
		let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		let seconds = Math.floor((distance % (1000 * 60)) / 1000);

		if (distance > 1 ) {
			blockDay.forEach((blockDay)=> {
				blockDay.innerHTML = days;
			});
			blockHour.forEach((blockHour)=> {
				blockHour.innerHTML = hours;
			});
			blockMinute.forEach((blockMinute)=> {
				blockMinute.innerHTML = minutes;
			});
			blockSecond.forEach((blockSecond)=> {
				blockSecond.innerHTML = seconds;
			});
		} else {
			blockDay.forEach((blockDay)=> {
				blockDay.innerHTML = '0';
			});
			blockHour.forEach((blockHour)=> {
				blockHour.innerHTML = '0';
			});
			blockMinute.forEach((blockMinute)=> {
				blockMinute.innerHTML = '0';
			});
			blockSecond.forEach((blockSecond)=> {
				blockSecond.innerHTML = '0';
			});

			dateSettings.sortDates();
			resetTimer();
		}
	}

	function resetTimer(timer) {
		clearInterval(timer);
	}

	function getClosestStartWeek(date) {
		date = new Date();
		let	targetDay = 1;

		let targetDate = new Date();
		let	delta = targetDay - date.getDay();

		if (delta >= -1) {
			targetDate.setDate(date.getDate() + delta);
		}	else {
			targetDate.setDate(date.getDate() + 7 + delta);
		}

		return targetDate;
	}

	function setupSelectors(dateSettings) {
		const selectorContainer = document.querySelector(SELECTORS.selectorContainer);
		const selectorContainerMobile = document.querySelector(SELECTORS.selectorContainerMobile);

		if (!selectorContainer || !selectorContainerMobile) {
			return;
		}

		selectorContainer.innerHTML = "";
		selectorContainerMobile.innerHTML = "";

		const deliveryDates = dateSettings.plannedDeliveries[0].deliveryDays;

		let absoluteIndex = 0;
		let deliveryDate = getClosestStartWeek(new Date());

		//current delivery week
		let mobileSlidesGroup = document.createElement("div");
		mobileSlidesGroup.classList.add("date-selector-wrapper");
		mobileSlidesGroup.classList.add("swiper-slide");

		for (let i = 1; i < 8; i++) {
			if (i > 1) {
				deliveryDate.setDate(deliveryDate.getDate() + 1);
			} else {
				deliveryDate.setDate(deliveryDate.getDate());
			}

			if (!absoluteIndex) {
				mobileSlidesGroup.setAttribute("data-slide-day-start", deliveryDate.toLocaleString(LOCALE_CODE, DEFAULT_DATES_FORMAT));
			}

			absoluteIndex++;

			const dateSelector = createDateSelector(deliveryDate, deliveryDates);
			const dateSelectorMobile = createDateSelectorMobile(deliveryDate, deliveryDates);

			if (dateSelector) {
				selectorContainer.appendChild(dateSelector);
			}

			if (dateSelectorMobile) {
				mobileSlidesGroup.appendChild(dateSelectorMobile);
			}
		}

		mobileSlidesGroup.setAttribute("data-slide-day-end", deliveryDate.toLocaleString(LOCALE_CODE, DEFAULT_DATES_FORMAT));
		selectorContainerMobile.appendChild(mobileSlidesGroup);

		//future dates
		let endDate = new Date();
        console.log(endDate)
		endDate = new Date(endDate.setDate(endDate.getDate() + 4 * 7));

		const featureDeliveryDates = generateFutureDatedDeliveryByRange([7], deliveryDate, endDate);

		let futureDeliveryRender = true;
		while(futureDeliveryRender) {
			deliveryDate.setDate(deliveryDate.getDate() + 1);

			if (absoluteIndex % 7 === 0) {
				mobileSlidesGroup = document.createElement("div");
				mobileSlidesGroup.classList.add("date-selector-wrapper");
				mobileSlidesGroup.classList.add("swiper-slide");
				mobileSlidesGroup.setAttribute("data-slide-day-start", deliveryDate.toLocaleString(LOCALE_CODE, DEFAULT_DATES_FORMAT));
			}

			absoluteIndex++;

			const dateSelector = createDateSelector(deliveryDate, featureDeliveryDates, true);
			const dateSelectorMobile = createDateSelectorMobile(deliveryDate, featureDeliveryDates, true)

			if (dateSelector) {
				selectorContainer.appendChild(dateSelector);
			}

			if (dateSelectorMobile) {
				mobileSlidesGroup.appendChild(dateSelectorMobile);
			}

			futureDeliveryRender = deliveryDate < endDate
				? true
				: absoluteIndex % 7;

			if (absoluteIndex % 7 === 0) {
				mobileSlidesGroup.setAttribute("data-slide-day-end", deliveryDate.toLocaleString(LOCALE_CODE, DEFAULT_DATES_FORMAT));
				selectorContainerMobile.appendChild(mobileSlidesGroup);
			}
		}


		// initDeliverySliders();
	}

	function updateWeekIndicators(slider, indicators) {
		if (!slider || !indicators || !indicators.length) {
			return;
		}

		let start = null;
		let end = null;

		const activeSlide = slider.slides[slider.realIndex];
		const lastActiveSlide = slider.slides[slider.realIndex + 6];

		if (!activeSlide && !lastActiveSlide) {
			return;
		}

		if (activeSlide && lastActiveSlide && window.innerWidth > MOBILE_BREAKPOINT) {
			start = activeSlide.dataset.slideDay;
			end = lastActiveSlide.dataset.slideDay;
		} else if (window.innerWidth <= MOBILE_BREAKPOINT) {
			start = activeSlide.dataset.slideDayStart;
			end = activeSlide.dataset.slideDayEnd;
		}

		if (!start || !end) {
			return;
		}

		indicators.forEach((indicator) => {
			indicator.innerHTML = `${start} - ${end}`
		});
	}

	function createDateSelector(deliveryDate, deliveryDays, future = false) {
		return dateSelectorFactory(deliveryDate, deliveryDays, future);
	}

	function createDateSelectorMobile(deliveryDate, deliveryDays, future = false) {
		return dateSelectorFactory(deliveryDate, deliveryDays, future, 'mobile');
	}

	function dateSelectorFactory (deliveryDate, deliveryDays, future = false, prefix = null) {
		let dateSelector = document.createElement("div");

		dateSelector.classList.add("date-selector");
		dateSelector.classList.add("swiper-slide");
		dateSelector.setAttribute("data-slide-day", deliveryDate.toLocaleString(LOCALE_CODE, DEFAULT_DATES_FORMAT));

		let isAvailable = false;
		for (let settingsDay of deliveryDays) {
			if (settingsDay.getDate() == deliveryDate.getDate()) {
				isAvailable = true;
				dateSelector.classList.add("available");
				dateSelector.setAttribute("data-date", deliveryDate.toLocaleString(DEFAULT_LOCALE).split(/\D/).slice(0,3).map(num=>num.padStart(2,"0")).join("/"));
				dateSelector.setAttribute("data-day", DAYS[deliveryDate.getDay()]);

				if (settingsDay.getDay() == 2) {
					dateSelector.setAttribute("data-time", "11:00 AM-06:00 PM");
				} else {
					dateSelector.setAttribute("data-time", "03:00 PM-09:00 PM");
				}

				dateSelector.addEventListener("click", selectDeliveryDate);

				if (!future && settingsDay == deliveryDays[0]) {
					const selectedDay = document.querySelector(`${SELECTORS.selectedDay}${prefix ? '-' + prefix : ''}`);
					const deliveryDate = document.querySelector(`${SELECTORS.deliveryDate}${prefix ? '-' + prefix : ''}`);
					const deliveryDay = document.querySelector(`${SELECTORS.deliveryDay}${prefix ? '-' + prefix : ''}`);
					const deliveryTime = document.querySelector(`${SELECTORS.deliveryTimeId}${prefix ? '-' + prefix : ''}`);

					selectedDay.innerHTML = settingsDay.toLocaleDateString(LOCALE_CODE, DEFAULT_DATES_FORMAT);
					deliveryDate.setAttribute("value", dateSelector.getAttribute("data-date"));
					deliveryDay.setAttribute("value", dateSelector.getAttribute("data-day"));
					deliveryTime.setAttribute("value", dateSelector.getAttribute("data-time"));

					dateSelector.classList.add("selected");
				}
			}
		}
		return (prefix && prefix === "mobile")
			? (isAvailable ? dateSelector : null)
			: dateSelector;
	}

	function selectDeliveryDate() {
		let selectedDayEls = document.querySelectorAll(SELECTORS.selectedDayByName);
		for (el of selectedDayEls) {
			el.innerHTML = new Date(this.getAttribute("data-date")).toLocaleDateString(LOCALE_CODE, DEFAULT_DATES_FORMAT);
		}

		let deliveryDateEls = document.querySelectorAll(SELECTORS.deliveryDateByName);
		for (el of deliveryDateEls) {
			el.setAttribute("value", this.getAttribute("data-date"));
		}

		let deliveryDayEls = document.querySelectorAll(SELECTORS.deliveryDayByName);
        console.log("Avant: ", this.getAttribute("data-date")); 

        console.log(this.getAttribute("data-day"));  
        console.log(this.getAttribute("data-time")); 
		for (el of deliveryDayEls) {
			el.setAttribute("value", this.getAttribute("data-day"));
		}

		let deliveryTimeEls = document.querySelectorAll(SELECTORS.deliveryTimeByName);
       
		for (el of deliveryTimeEls) {
			el.setAttribute("value", this.getAttribute("data-time"));
		}

		let selectorTimeEls = document.querySelectorAll(SELECTORS.selectorDeliveryTimeByName);
		for (el of selectorTimeEls) {
			el.setAttribute("value", this.getAttribute("data-time"));
			el.innerHTML = this.getAttribute("data-time");
		}

		for (let element of document.querySelectorAll(SELECTORS.dateSelector)) {
			element.classList.remove("selected");
		}

		let selectedSelectorEls = document.querySelectorAll('[data-date="' + this.getAttribute("data-date") + '"]');
		for (el of selectedSelectorEls) {
			el.classList.add("selected");
		}
        console.log("Après: ", this.getAttribute("data-date")); 
        console.log(this.getAttribute("data-day"));  
        console.log(this.getAttribute("data-time")); 
		if (window.ReCharge) {
			ReCharge.cart.attributes = getAttributes().attributes;
		}
	}

	function initWeeklySlider() {
		if (!window.weeklySlider) {

			let slides = document.querySelectorAll(SELECTORS.weeklySlide);

			if (!slides) {
				return;
			}

			window.weeklySlider = new Swiper(SELECTORS.weeklySlider, {
				slidesPerView: 1,
				autoHeight: true,
				slidesPerGroup: 1,
				initialSlide: 1,
				allowTouchMove: false,
				navigation: {
					nextEl: SELECTORS.weeklySliderNavNext,
					prevEl: SELECTORS.weeklySliderNavPrev,
				},
				on: {
					slideChange: function (swiper) {
						swiper.navigation.update();
					},
					toEdge: function (swiper) {
						swiper.navigation.update();
					}
				}
			});

			window.weeklySlider.navigation.update();
		}
	}

	function initDeliverySlider() {
		if (!window.deliverySelectorsSliderMobile) {
			window.deliverySelectorsSliderMobile = initSlider(SELECTORS.mobileSlider, {
				slidesPerView: 1,
				slidesPerGroup: 1,
				navigation: {
					nextEl: SELECTORS.mobileSliderNavNext,
					prevEl: SELECTORS.mobileSliderNavPrev,
				}
			});

			window.deliverySelectorsSliderMobile.navigation.update();
		}

		if (!window.deliverySelectorsSlider) {
			window.deliverySelectorsSlider = initSlider(SELECTORS.slider);

			window.deliverySelectorsSlider.navigation.update();

			const indicators = document.querySelectorAll(SELECTORS.weekIndicator);

			if (window.innerWidth > MOBILE_BREAKPOINT) {
				updateWeekIndicators(window.deliverySelectorsSlider, indicators);
			} else {
				updateWeekIndicators(window.deliverySelectorsSliderMobile, indicators);
			}

			window.deliverySelectorsSliderMobile.on('slideChange', function (swiper) {
				updateWeekIndicators(swiper, indicators);

				if (window.innerWidth > MOBILE_BREAKPOINT) {
					return;
				}

				const index = swiper.activeIndex;
				const prevIndex = swiper.previousIndex;

				if (index > prevIndex) {
					window.deliverySelectorsSlider.slideNext(0);
				} else if (index < prevIndex) {
					window.deliverySelectorsSlider.slidePrev(0);
				}
			});

			window.deliverySelectorsSlider.on('slideChange', function (swiper) {
				updateWeekIndicators(swiper, indicators);

				if (window.innerWidth <= MOBILE_BREAKPOINT) {
					return;
				}

				const index = swiper.activeIndex;
				const prevIndex = swiper.previousIndex;

				if (index > prevIndex) {
					window.deliverySelectorsSliderMobile.slideNext(0);
				} else if (index < prevIndex) {
					window.deliverySelectorsSliderMobile.slidePrev(0);
				}
			});

			window.addEventListener("resize", () => {
				window.deliverySelectorsSlider.navigation.update();
			});
		}
	}

	function initSlider(selector, options) {
		if (!window.Swiper) {
			return;
		}

		return new Swiper(selector, {
			slidesPerView: "auto",
			slidesPerGroup: 7,
			allowTouchMove: false,
			navigation: {
				nextEl: SELECTORS.sliderNavNext,
				prevEl: SELECTORS.sliderNavPrev,
			},
			on: {
				slideChange: function (swiper) {
					swiper.navigation.update();
				},
				toEdge: function (swiper) {
					swiper.navigation.update();
				}
			},
			...options
		});
	}

	function setWeekForProducts() {
		let slides = document.querySelectorAll(SELECTORS.weeklySlide);

		if (slides.length == 0) {
			return;
		}

		let week = null;

		slides.forEach((menu)=> {
			week = menu.getAttribute('data-week');

			let productsWeekAttribute = menu.querySelectorAll('[name="properties[Weekly menu]"]');

			productsWeekAttribute.forEach((productWeekAttribute)=> {
				productWeekAttribute.value = week;
			});
		});
	}

	function checkWeeklyCollection() {
		document.addEventListener('cart:updated', (e) => {
			let isWeeklyInCart = false;

			if (e.detail.item_count == 0) {
				window.localStorage.setItem("selectedWeeklyCollections", '');
				window.localStorage.setItem("selectedWeek", '');
			}

			if (e.detail.item_count > 0) {
				e.detail.items.forEach((item) => {
					if (item.properties['Weekly menu']) {
						isWeeklyInCart = true;
					}
				});

				if (isWeeklyInCart != true) {
					window.localStorage.setItem("selectedWeeklyCollections", '');
					window.localStorage.setItem("selectedWeek", '');
				}
			}
		});

		document.addEventListener('product:added', (e) => {
			if (e.detail.closest(SELECTORS.weeklySlide)) {

				let selectedCollection = e.detail.closest(SELECTORS.weeklySlide)?.getAttribute('data-weekly-collection');
				let selectedWeek = e.detail.closest(SELECTORS.weeklySlide)?.getAttribute('data-week');
				window.localStorage.setItem("selectedWeeklyCollections", selectedCollection);
				window.localStorage.setItem("selectedWeek", selectedWeek);
			}

			disableWeeklyCollection();
		});

		disableWeeklyCollection();
	}

	function disableWeeklyCollection() {
		let slides = document.querySelectorAll(SELECTORS.weeklySlide);
		let selectedCollection = window.localStorage.getItem("selectedWeeklyCollections");

		if (slides.length == 0 ) {
			return;
		}

		if (!selectedCollection) {
			return;
		}

		slides.forEach((menu)=> {

			if (menu.getAttribute('data-weekly-collection') != selectedCollection) {

				menu.querySelectorAll('.quick-add--add-button').forEach((button) => {
					button.classList.add('hidden');
				});

				menu.querySelectorAll('.weekly-menu-message').forEach((message) => {
					message.classList.remove('hidden');
				});
			}
		});
	}

	function cartMenuStyle() {
		let cartDeliverySelector = document.querySelectorAll('.selector-wrapper');
		let currentWeek = window.localStorage.getItem("selectedWeek");

		if (!cartDeliverySelector || !currentWeek) {
			return;
		}

		let weekClass = 'selector-wrapper--week-first';

		if (+currentWeek == 2) {
			weekClass = 'selector-wrapper--week-second';
		} else if (+currentWeek == 3) {
			weekClass = 'selector-wrapper--week-third';
		}

		cartDeliverySelector.forEach((selector) => {
			selector.classList.add(weekClass, 'selector-wrapper--has-weekly');
		});
	}

	window.buildSelector = function() {
		let myPlannedDelivery = new DatedDelivery([7], 3, 2359);
		let myOtherPlannedDelivery = new DatedDelivery([7], 3, 2359);

		let selectorSettings = new DateSettings([myOtherPlannedDelivery, myPlannedDelivery]); //Generated from theme settings

		setupSelectors(selectorSettings);
      
		let selectorsWrapper = document.querySelectorAll('.selector-container');

		selectorsWrapper.forEach((selectorWrapper) => {
			let selectors = selectorWrapper.querySelectorAll('.date-selector.available');

			if (selectors.length > 0) {
				for (let i = 0; i < selectors.length; i++) {
					if (window.getComputedStyle(selectors[i], null).getPropertyValue('display') == 'flex') {
                        console.log(selectors[i])
						selectors[i].dispatchEvent(new Event("click"));
						break;
					}
				}
			}
		});

        let d = new Date()
        let n = d.getDay()
        let h = d.getHours()
        let s = document.querySelector('.cart--form > .selector-wrapper--week-first .delivery-schedule')
        let t = document.querySelector('.cart--form > .selector-wrapper--week-first #time-selector')
        if(n == 4 || n == 0 || (n == 3 && h >= 18)) {
          console.log(h)
          s.style.display = 'none'
          t.style.display = 'none'
          
          let selectorsWrapper = document.querySelectorAll('.selector-container');
          selectorsWrapper.forEach((selectorWrapper) => {
			let selectors = selectorWrapper.querySelectorAll('.date-selector.available');

			if (selectors.length > 0) {
				for (let i = 0; i < selectors.length; i++) {
					selectors[i].classList.remove('available', 'selected')
                    selectors[i].style.pointerEvents = 'none'
				}
			}
		});
        }

      
	};
})();
